import React from 'react';

import { Dialog } from '@shared/components';

import Chip from '@material-ui/core/Chip';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';

import useStyle from './style';

const noop = () => {};

const ProgressDialog = ({
  open = false,
  label = '',
  remainingItem = 0,
  totalItem = 0,
  hideProgressBar = false,
  isRateLimited = false,
  rateLimitDelay = 0,
  handleClose = noop,
}) => {
  const classes = useStyle();
  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      open={open}
      onClose={handleClose}
      classes={{
        paper: classes.progressDialog,
      }}
    >
      <Dialog.Title className='pl-0 pt-0 pr-0 pb-0' hasClose/>
      <Dialog.Content>
        <div className='d-flex f-align-center f-justify-center flex-column h-100'>
          {!hideProgressBar && (
            <Typography variant='h4' className='text-bold'>
              {remainingItem}
            </Typography>
          )}
          <Typography variant='body2' className='text-bold mb-6'>
            {label}
          </Typography>
          {!hideProgressBar ? (
            <>
              <LinearProgress
                variant='determinate'
                value={((totalItem - remainingItem) / totalItem) * 100}
                className='w-100'
                classes={{
                  root: classes.linearProgressRoot,
                  bar: classes.linearProgressBar,
                  colorPrimary: classes.linearProgresscolorPrimary,
                }}
              />
              <Typography variant='body2' className='w-100'>
                {Math.floor(((totalItem - remainingItem) / totalItem) * 100)}%
              </Typography>
            </>
          ) : (
            <LinearProgress
              className='w-100'
              classes={{
                root: classes.linearProgressRoot,
                bar: classes.linearProgressBar,
                colorPrimary: classes.linearProgresscolorPrimary,
              }}
            />
          )}
          {isRateLimited && (
            <div className='d-flex f-align-center f-justify-center mt-4'>
              <Chip
                label={`Oops! Rate limit exceeded. Download will resume in ${rateLimitDelay ||
                  '60'} seconds.`}
                color='primary'
                className='mr-4 mt-2 mb-2 bg-danger color-white'
              />
            </div>
          )}
        </div>
      </Dialog.Content>
    </Dialog>
  );
};

export default ProgressDialog;
